import { render } from "./CompanyEvaluation.vue?vue&type=template&id=67648971&scoped=true&lang=html"
import script from "./CompanyEvaluation.vue?vue&type=script&lang=js"
export * from "./CompanyEvaluation.vue?vue&type=script&lang=js"

import "./CompanyEvaluation.vue?vue&type=style&index=0&id=67648971&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-67648971"

export default script